// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ContactModel from '../../model/contact-model';
import ContactDTO from '../dto/contact-dto';
import dtoSchema from '../schemas/contact-schema';
import ContactAddressModel from '../../model/contact-address-model';

export default abstract class ContactModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ContactDTO>) {
    super();
    if (data) {
      this.customerNumber = data.customerNumber ?? undefined;
      this.contactNumber = data.contactNumber ?? undefined;
      this.contactId = data.contactId ?? undefined;
      this.parentContactId = data.parentContactId ?? undefined;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.address = data.address ? ContactAddressModel.toModel(data.address) : undefined;
    }
  }
  /**
  * @type {int32}
  */
  customerNumber?: number;
  /**
  * @type {int32}
  */
  contactNumber?: number;
  /**
  * @type {uuid}
  */
  contactId?: string;
  /**
  * @type {uuid}
  */
  parentContactId?: string;
  /**
  */
  languageIso2?: string;
  /**
  */
  address?: ContactAddressModel;

  static toModel(dto: DeepPartial<ContactDTO>): ContactModel;
  static toModel(dto: DeepPartial<ContactDTO> | undefined | null): ContactModel | undefined;
  static toModel(dto: DeepPartial<ContactDTO> | undefined | null): ContactModel | undefined {
    return dto ? new ContactModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ContactModel> | ContactModel): ContactDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      customerNumber: unwrapped.customerNumber,
      contactNumber: unwrapped.contactNumber,
      contactId: unwrapped.contactId,
      parentContactId: unwrapped.parentContactId,
      languageIso2: unwrapped.languageIso2,
      address: unwrapped.address,
    } as ContactDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ContactModel, can not map to ContactDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
